import { render, staticRenderFns } from "./ClientLevelPoints.vue?vue&type=template&id=937a0ef4&scoped=true"
import script from "./ClientLevelPoints.vue?vue&type=script&lang=js"
export * from "./ClientLevelPoints.vue?vue&type=script&lang=js"
import style0 from "./ClientLevelPoints.vue?vue&type=style&index=0&id=937a0ef4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937a0ef4",
  null
  
)

export default component.exports